export const getReferencedPropertiesQuery = `
  query GetConfigData(
    $leadAttributeSchemaNames: [String!], 
    $userUuids: [String!], 
    $activityIds: [Int!], 
    $salesGroupIds: [Int!],
    $taskTemplateIds: [Int!]
    $leadAttributeOptionIds: [Int!]
  ) {
  configData(
    leadAttributeSchemaNames: $leadAttributeSchemaNames, 
    userUuids: $userUuids, 
    activityIds: $activityIds,
    salesGroupIds: $salesGroupIds,
    taskTemplateIds: $taskTemplateIds,
    leadAttributeOptionIds: $leadAttributeOptionIds
  ) {
    leadAttributes {
      id
      attributeName
      schemaName
      leadAttributeUuid
      dataType
      leadAttributeType
      defaultMailMergeValue
    }
    leadAttributeOptions {
      id
      optionName
    }
    users {
      id
      firstName
      lastName
      email
      userUuid
    }
    activities {
      key: id
      value: displayName
      activityAttributes {
        id
        value: attributeName
        key: schemaName
        dataType
        activityAttributeOptions {
          key: id
          value: optionName
        }
      }
    }
    salesGroups {
      id
      name
    }
    tasks {
      id
      name
    }
  }
}
`;

export const getAllSalesGroups = `
  query getAllSalesGroups {
    salesGroups {
      id
      name
    }
  }
`;

export type LeadAttributeOptionsType = {
  id: string;
  optionName: string;
};

export type LeadAttributesType = {
  id: string;
  attributeName: string;
  schemaName: string;
  leadAttributeUuid: string;
  dataType: string;
  leadAttributeType: string;
  defaultMailMergeValue: string;
};

export type UsersType = {
  id: number;
  firstName: string;
  lastName: string;
  fullName: string;
  email: string;
  userUuid: string;
};

export type ActivityAttributeOption = {
  key: string;
  value: string;
};

export type ActivityAttribute = {
  id: string;
  value: string;
  key: string;
  dataType: string;
  // todo: Fetch Attribute Options seperately, This can cause issues if we fetch all options at once
  activityAttributeOptions: ActivityAttributeOption[];
};

export type ActivitiesType = {
  key: string;
  value: string;
  activityAttributes: ActivityAttribute[];
};

export type AttributeOptionsType = {
  value: string;
  label: string;
  config: {
    colorScheme: string;
  };
};

export type SalesGroupType = {
  id: number;
  name: string;
};

export type TaskType = {
  id: number;
  name: string;
};

export type GetReferencedPropertiesType = {
  configData: {
    leadAttributes: LeadAttributesType[];
    leadAttributeOptions: LeadAttributeOptionsType[];
    users: UsersType[];
    activities: ActivitiesType[];
    leadStageOptions: AttributeOptionsType[];
    leadSourceOptions: AttributeOptionsType[];
    salesGroups: SalesGroupType[];
    tasks: TaskType[];
  };
};
